export default class Menu {
  constructor(el, config) {

    config = Object.assign({}, {
      pageScroll: true,
      extensions: [
        'theme-dark',
        'shadow-page',
        'border-full',
        'pagedim-black',
        'fx-menu-slide',
        'fx-listitems-slide'
      ]
    }, config)

    this.api = $(el).mmenu(config);
  }
}



// WEBPACK FOOTER //
// ./resources/js/modules/mmenu/index.js